const HassanRaza = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="max-w-[70rem] mx-auto sm:px-[10rem] lg:flex md:grid md:justify-center lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] sm:text-[30px] font-bold">
              Hassan Raza Leghari
            </h1>
            <p>CEO TCS Private Limited</p>
          </div>
          <div className="flex justify-end mx-[2rem]">
            <img
              src="/leadershipnew/HassanRazaLeghari4.jpg"
              alt=""
              className="xl:h-[26rem] lg:h-[26rem] md:h-[20rem] sm:h-[20rem] h-[17rem] leadership-images"
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="sm:text-[30px] text-[26px] font-bold">
              Hassan Raza Leghari
            </h1>
            <p>CEO TCS Private Limited</p>
          </div>
        </div>
      </div>
      <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-justify gap-4">
        <p>
          With over 26 years of distinguished leadership experience in courier,
          express, and logistics, Mr. Hassan Raza Leghari has consistently
          driven operational excellence growth across Pakistan and the Asia
          Pacific region. His tenure at DHL Express is marked by visionary
          leadership, large-scale operational transformations, and strengthening
          of strategic regulatory and industry partnerships.
        </p>
        <p>
          From 2008 to 2015, as Head of Operations, Mr. Hassan propelled DHL
          Express Pakistan to market-leading transit times and operational
          distinctions, earning recognition for innovation and performance.
        </p>
        <p>
          In 2015, Mr. Hassan transitioned to the DHL APEC Regional Office in
          Singapore, leading operations across 35+ countries. With his trademark
          energy and commitment, he has delivered numerous achievements and
          initiatives across the region. He has been deeply committed to people
          development, deploying network operations efficiency programs being a
          certified international manager and coaching for success facilitator.
        </p>
        <p>
          Mr.Hassan has been an integral part of courier, express and logistics
          business. A true ambassador of our values, passion and excellence.
        </p>
      </div>
    </div>
  );
};

export default HassanRaza;
